module.exports = __webpack_public_path__ + "static/img/home9.08269879.png";